import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Drawer, DrawerProps, notification } from 'antd';

import { useBrandsSlice, useJoinOfferMutation } from 'entities/Brand';
import { useDisableBodyScroll, useMeta } from 'shared/hooks';
import { EYmEvents, EYmEventsO1, EYmEventsO2 } from 'shared/typings';
import { JoinForm } from 'shared/ui';
import { sendYmEvent } from 'shared/utils';

interface IJoinOfferProps extends DrawerProps {}

export const JoinOffer: FC<IJoinOfferProps> = ({ ...props }) => {
	const { t } = useTranslation();
	const { joinedOffer, joinedSources, setJoinedOffer, setJoinedSources } = useBrandsSlice();
	const [joinOffer, { status, isLoading }] = useJoinOfferMutation();
	const { activeSourcesOptions, sourceCanJoin } = useMeta();

	const sourceOptions = activeSourcesOptions.filter(({ value: sourceUuid }) =>
		sourceCanJoin(sourceUuid, joinedOffer?.offer?.sources_relations || []),
	);

	useDisableBodyScroll(!!joinedOffer);

	useEffect(() => {
		if (status === 'fulfilled') {
			sendYmEvent({
				event: EYmEvents.SEND_JOIN_SUCCESS,
				o1: [EYmEventsO1.ACCOUNT, EYmEventsO1.PUBLISHER, EYmEventsO1.CATALOG],
				o2: EYmEventsO2.JOIN,
				pi: joinedOffer?.offer?.uuid,
				wi: joinedSources?.join(';'),
			});

			setJoinedOffer(null);
			setJoinedSources(null);
			notification.open({
				message: t('Заявка отправлена успешно'),
				description: t('После прохождения модерации ваши площадки будут подключены к офферу'),
				type: 'success',
				placement: 'topRight',
				showProgress: true,
				pauseOnHover: true,
			});
		}
	}, [status]); // eslint-disable-line

	if (!joinedOffer) return null;

	return (
		<Drawer
			{...props}
			open={!!joinedOffer}
			onClose={() => setJoinedOffer(null)}
			width={650}
			title={t('Подключение к офферу')}>
			<JoinForm
				type="offer"
				brand={joinedOffer.brand}
				offer={joinedOffer.offer}
				isLoading={isLoading}
				sourceOptions={sourceOptions}
				onJoin={joinOffer}
				onClose={() => setJoinedOffer(null)}
			/>
		</Drawer>
	);
};
